import { Component, OnDestroy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { CbService } from '@app/Modules/chargeback/Services/cb.service';
import { HttpChargeBackService } from '@app/Modules/Shared/Services/http-charge-back.service';
import { CpAgGridService } from '@app/Modules/cp-grid/services/cp-ag-grid-service';
import { MessageService } from 'primeng/api';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';

@AutoUnsubscribe()

@Component({
  selector: 'kcfile-history-download',
  templateUrl: './kcfile-history-download.component.html',
  styleUrls: ['./kcfile-history-download.component.scss']
})

export class KcfileHistoryDownloadComponent implements AgRendererComponent, OnDestroy {

  params: any;
  isdownloadLatest: boolean = false;
  isdownloadOlder: boolean = false;
  fileversion: number;
  subscription: Subscription = new Subscription();
  linesInFile: number;
  
  constructor(
    private cbServ: CbService,
    private httpServ: HttpChargeBackService,
    private gridService: CpAgGridService,
    private messageService: MessageService,
    private appServ: AppService
  ) { }

  agInit(params: any) {
    this.params = params;
    this.linesInFile = this.cbServ.totalLinesInFile;
    let HighestRowIndex = this.cbServ.getRowCount() - 1;
    if(this.params.rowIndex === 0){
      this.isdownloadLatest = true;
      this.fileversion = 1;
    }
    else if (this.params.rowIndex > 0 && this.params.rowIndex === HighestRowIndex){
      this.isdownloadOlder = true;
      this.fileversion = 0;
    }
  }

  svcCall(){
    this.appServ.setLoadingStatus(true);
    let pageContext  = this.gridService.pageContext;
    let request = {
      "claimFileId": pageContext.request.claimFileId,
      "salesOrgId": pageContext.request.salesOrgId,
      "fileversion": this.fileversion
    }
    this.subscription.add(this.httpServ.kcfileDownload(request).subscribe((res) => {
      if (res && res.fileUrl) {
        window.open(res.fileUrl, '_blank');
      }
      else {
        this.messageService.add({ key: 'kcfileDownload', detail: 'An unexpected error occurred. Please try again.', summary: 'Error', severity: 'error' })
      }
    },
      (e) => {
        this.messageService.add({ key: 'kcfileDownload', detail: 'An unexpected error occurred. Please try again.', summary: 'Error', severity: 'error' });
      },
      () => {
        this.appServ.setLoadingStatus(false);
      }
    ));
  }

  refresh(params: any): boolean {
    return false;
  }

  ngOnDestroy(){

  }
}
